import { inputClasses } from '@mui/material';
import { textInputColors } from '../constants';
const styleOverrides = {
  root: {
    padding: '4px 0 3px',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    'input::placeholder': {
      color: textInputColors.placeholder,
      opacity: 1,
      transition: 'none'
    }
  },
  formControl: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- css selector
    'label + &': {
      marginTop: 10
    }
  },
  inputSizeSmall: {
    paddingTop: 6
  },
  underline: {
    [`&:not(.${inputClasses.disabled}):hover:before`]: {
      borderBottomWidth: 0.75
    },
    '&:after': {
      borderBottomWidth: 1.2
    }
  },
  multiline: {
    padding: '10px 0 10px'
  }
};
export default {
  styleOverrides
};